import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import 'bootstrap/dist/css/bootstrap.min.css';


// Pages
import HomePage from './pages/HomePage';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';

// Context
import { AuthProvider, useAuth } from './context/AuthContext';
import License from "./pages/License";
import Ijara from "./pages/Ijara";
import Putyovka from "./pages/Putyovka";
import Litsenziya from "./pages/Litsenziya";
import Transport from "./pages/Transport";
import TransportAdd from "./pages/TransportAdd";
import TransportAdd2 from "./pages/TransportAdd2";
import Putyovka2 from "./pages/Putyovka2";
import Litsenziya2 from "./pages/Litsenziya2";
import Ijara2 from "./pages/Ijara2";
import Users from "./pages/Users";
import TransportShow from "./pages/TransportShow";
import ShowPutyovka from "./pages/show/ShowPutyovka";
import UserProfile from "./pages/UserProfile";
import { ToastContainer } from 'react-toastify';
import Kassa from "./pages/Kassa";
import ErrorPage from "./pages/ErrorPage";
import PutyovkaWizard from "./components/putyovka";

// Create theme
const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
});

// Private Route Component
const PrivateRoute = ({ children }) => {
  const { currentUser } = useAuth();
  return currentUser ? children : <Navigate to="/login" />;
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/error" element={<ErrorPage />} />
            <Route path="/login" element={<Login />} />
            {/*<Route path="/register" element={<Register />} />*/}
            <Route path="/dashboard" element={<Dashboard />}>
              <Route index element={<Transport />} /> {/* Default dashboard content */}
              {/*<Route path="license" element={<Litsenziya />} />*/}
              <Route path="license" element={<Litsenziya2 />} />
              <Route path="transport" element={<Transport />} />
              <Route path="transport/add" element={<TransportAdd2 />} />
              <Route path="transport/edit/:id" element={<TransportAdd2 />} />
              <Route path="transport/show/:id" element={<TransportShow />} />
              {/*<Route path="putyovka" element={<Putyovka />} />*/}
              <Route path="putyovka" element={<Putyovka2 />} />
              <Route path="putyovka/edit/:id" element={<PutyovkaWizard isEdit={true} />} />
              <Route path="putyovka/new" element={<PutyovkaWizard />} />

              <Route path="rent" element={<Ijara2 />} />
              <Route path="user" element={<Users />} />
              <Route path="profile" element={<UserProfile />} />
              <Route path="kassa" element={<Kassa />} />
              <Route path="*" element={<Navigate to="/" replace />} />
              {/*<Route path="drivers" element={<Drivers />} />*/}
              {/*<Route path="profile" element={<Profile />} />*/}
            </Route>
            <Route path="putyovka/history/:transportId" element={<ShowPutyovka />} />
            <Route
              path="/dashboard/*"
              element={
                <PrivateRoute>
                  <Dashboard />
                </PrivateRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <ToastContainer
              position="top-right"
              autoClose={3000}
              toastStyle={{ zIndex: 9999 }} // 👈 z-index yuqoriroq bo'lishi kerak
          />
        </AuthProvider>
      </Router>
    </ThemeProvider>
  );
}

export default App;
